import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthState } from '../state/auth.state';

export const authGuard: CanActivateFn = (route) => {
  const auth = inject(AuthState);
  const router = inject(Router);

  if (auth.currentUser()) {
    return true;
  }

  const fragment = route.fragment;
  return router.createUrlTree(['/login'], { fragment: fragment?.startsWith('invitation=') ? fragment : undefined });
};
